export enum ActivityType {
  NewsUpdated = 73,
  NewsArchived = 74,
  NewsUnarchived = 75,
}
